import { useEffect, useState } from 'react';

export const getElapsedMinutes = (from?: Date | null) => {
  if (!from) return 0;
  return Math.max(0, Math.floor((Date.now() - from.getTime()) / 60000));
};

export const getTimeBadgeClass = (minutes: number) =>
  minutes >= 20
    ? 'border-transparent bg-red-500 text-white'
    : minutes >= 10
      ? 'border-transparent bg-amber-500 text-white'
      : 'bg-muted text-muted-foreground';

export const useElapsedMinutes = (from?: Date | null) => {
  const [minutes, setMinutes] = useState(() => getElapsedMinutes(from));

  useEffect(() => {
    const update = () => setMinutes(getElapsedMinutes(from));
    update();
    const interval = window.setInterval(update, 30_000);
    return () => window.clearInterval(interval);
  }, [from]);

  return minutes;
};
